/* mo-bf-sale-hub: brand filter, sort and show-all over the server-rendered Black Friday cards (Hermes, lane sale, 2026-11-03).
   The server order is "each brand in turn"; the default view keeps that order, so the first screen does not move.
   A link to #bf-<key> (for example /collections/everyday-sale-prices#bf-purple) opens with that brand picked. */
(function () {
  'use strict';
  function init(root) {
    if (root.__bfs) return; root.__bfs = 1;
    var grid = root.querySelector('[data-bfs-grid]');
    if (!grid) return;
    var rest = root.querySelector('[data-bfs-rest]');
    if (rest) {
      Array.prototype.slice.call(rest.querySelectorAll('[data-bfs-card]')).forEach(function (c) { grid.appendChild(c); });
      rest.parentNode.removeChild(rest);
    }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-bfs-card]'));
    var scope = root.hasAttribute('data-bfs-ext') ? document : root;
    var brandBtns = Array.prototype.slice.call(scope.querySelectorAll('[data-bfs-brand]'));
    var allBtn = root.querySelector('.mo-bfs-all[data-bfs-brand="all"]');
    var sortSel = root.querySelector('[data-bfs-sort]');
    var moreBtn = root.querySelector('[data-bfs-more]');
    var countEl = root.querySelector('[data-bfs-count]');
    var selEl = root.querySelector('[data-bfs-sel]');
    var wide = window.matchMedia('(min-width: 900px)');
    var first = parseInt(root.getAttribute('data-first'), 10) || 8;
    var state = { brand: 'all', sort: 'feat', all: false };
    var num = function (c, k) { return parseInt(c.getAttribute('data-' + k), 10) || 0; };
    var sorters = {
      feat: function (a, b) { return num(a, 'feat') - num(b, 'feat'); },
      save: function (a, b) { return (num(b, 'save') - num(a, 'save')) || (num(a, 'price') - num(b, 'price')) || (num(a, 'feat') - num(b, 'feat')); },
      low: function (a, b) { return (num(a, 'price') - num(b, 'price')) || (num(a, 'feat') - num(b, 'feat')); },
      high: function (a, b) { return (num(b, 'price') - num(a, 'price')) || (num(a, 'feat') - num(b, 'feat')); }
    };
    function limit() { return wide.matches ? Math.max(first, 12) : Math.min(first, 4); }
    function label(key) {
      var b = scope.querySelector('.mo-bfs-brand__btn[data-bfs-brand="' + key + '"]');
      return b ? b.getAttribute('data-label') : '';
    }
    function apply() {
      var list = cards.filter(function (c) { return state.brand === 'all' || c.getAttribute('data-brand') === state.brand; });
      list.sort(sorters[state.sort] || sorters.feat);
      var cap = state.all ? list.length : limit();
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= cap; });
      var n = list.length;
      var name = state.brand === 'all' ? '' : label(state.brand);
      if (countEl) countEl.textContent = n + (n === 1 ? ' bed' : ' beds') + (name ? ' from ' + name : '');
      if (moreBtn) {
        moreBtn.hidden = n <= cap;
        moreBtn.textContent = 'See all ' + n + (name ? ' ' + name : '') + (n === 1 ? ' bed' : ' beds');
      }
      brandBtns.forEach(function (b) {
        var k = b.getAttribute('data-bfs-brand');
        var on = k === state.brand;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var li = b.closest('.mo-bfs-brand');
        if (li) li.classList.toggle('is-on', on && k !== 'all');
      });
      if (allBtn) allBtn.hidden = state.brand === 'all';
      if (selEl) {
        var li = state.brand === 'all' ? null : scope.querySelector('.mo-bfs-brand[data-bfs-key="' + state.brand + '"]');
        var line = li ? li.querySelector('[data-bfs-line]') : null;
        if (line && line.textContent.trim()) {
          selEl.innerHTML = '';
          var t = document.createElement('span');
          t.innerHTML = line.innerHTML;
          selEl.appendChild(t);
          selEl.appendChild(document.createTextNode(' '));
          var a = document.createElement('a');
          a.href = '#bf-terms-' + state.brand;
          a.textContent = 'Offer details';
          selEl.appendChild(a);
          selEl.hidden = false;
        } else {
          selEl.hidden = true;
        }
      }
    }
    brandBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-bfs-brand');
        state.brand = (k === state.brand || k === 'all') ? 'all' : k;
        state.all = false;
        apply();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { state.all = true; apply(); });
    if (wide.addEventListener) wide.addEventListener('change', function () { if (!state.all) apply(); });
    function fromHash() {
      var m = /^#bf-([a-z]+)$/.exec(location.hash || '');
      if (!m) return false;
      var ok = scope.querySelector('.mo-bfs-brand__btn[data-bfs-brand="' + m[1] + '"]');
      if (!ok) return false;
      state.brand = m[1]; state.all = false;
      return true;
    }
    fromHash();
    window.addEventListener('hashchange', function () { if (fromHash()) apply(); });
    apply();

    /* fade the ledger's cut edge while more brands sit off screen */
    var wrap = root.querySelector('.mo-bfs-ledger-wrap');
    var led = root.querySelector('.mo-bfs-ledger');
    if (wrap && led) {
      var edge = function () { wrap.classList.toggle('is-more', led.scrollWidth - led.clientWidth - led.scrollLeft > 8); };
      led.addEventListener('scroll', edge, { passive: true });
      window.addEventListener('resize', edge);
      edge();
    }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mo-bfs]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
